import React from 'react'
import Icon from 'components/elements/Icon'

import { EstimatedBudget } from 'services/apiTypes/deck.types'

import styles from './budget.module.scss'

type Props = {
  budget?: EstimatedBudget
  className?: string
}

const Budget = ({ budget, className = '' }: Props) => {
  if (!budget) return <span>None</span>

  return (
    <span className={`${styles.icons} ${className}`}>
      {[...Array(budget).keys()].map(i => (
        <Icon key={i} name="dollar sign" />
      ))}
    </span>
  )
}

export default Budget
